<template>
    <analytics-category-card :category="category" :href="props.href">
        <div class="gap-1 justify-between grid grid-cols-1 @xl:grid-cols-12">
            <category-resource-card
                v-for="type in resourceTypeValues"
                :key="type"
                :resourceType="type"
                :category="props.category.value"
                :fetchParams="props.fetchParams"
                class="min-h-24 col-span-12 @xl:col-span-6 @4xl:col-span-4"
            />
        </div>
    </analytics-category-card>
</template>

<script setup>
import { metricsInputValidator, resourceTypeValues } from '~/utils/analytics';
import AnalyticsCategoryCard from '~/components/analytics/partial/category-metrics/AnalyticsCategoryCard.vue';
import CategoryResourceCard from '~/components/analytics/partial/category-metrics/CategoryResourceCard.vue';

const props = defineProps({
    category: {
        type: Object,
        required: true,
    },
    fetchParams: {
        type: Object,
        required: true,
        validator: metricsInputValidator,
    },
    href: {
        type: String,
    },
});
</script>
